import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      RATE: "Gi karakter:",
      WHAT_COULD_HAVE_BEEN_BETTER: "Hva kunne vært bedre?",
      DO_YOU_HAVE_MORE_FEEDBACK_FEEL_FREE_TO_LEAVE_A_COMMENT:
        "Har du mer feedback? Legg gjerne igjen en kommentar!",
      WHAT_MADE_THE_DISH_SO_GOOD: "Hva var det som gjorde retten så god?",
      ADD_A_COMMENT_AND_MAKE_THE_CHEF_HAPPY:
        "Legg til en kommentar - da blir kokken glad!",
      SAVE_AND_CLOSE: "Lagre og lukk",
    },
    se: {
      RATE: "Betygsätt:",
      WHAT_COULD_HAVE_BEEN_BETTER: "Vad kunde varit bättre?",
      DO_YOU_HAVE_MORE_FEEDBACK_FEEL_FREE_TO_LEAVE_A_COMMENT:
        "Har du mer feedback? Lämna gärna en kommentar!",
      WHAT_MADE_THE_DISH_SO_GOOD: "Vad var det som gjorde rätten så bra?",
      ADD_A_COMMENT_AND_MAKE_THE_CHEF_HAPPY:
        "Lägg till en kommentar och gör kocken glad",
      SAVE_AND_CLOSE: "Spara och stäng",
    },
    dk: {
      RATE: "Bedøm:",
      WHAT_COULD_HAVE_BEEN_BETTER: "Hvad kunne have været bedre?",
      DO_YOU_HAVE_MORE_FEEDBACK_FEEL_FREE_TO_LEAVE_A_COMMENT:
        "Har du mere feedback? Efterlad gerne en kommentar!",
      WHAT_MADE_THE_DISH_SO_GOOD: "Hvad var det, der gjorde retten så god?",
      ADD_A_COMMENT_AND_MAKE_THE_CHEF_HAPPY:
        "Tilføj en kommentar og gør kokken glad",
      SAVE_AND_CLOSE: "Gem og luk",
    },
  } as const
)[language];
